import useDelayUnmount from "../../../hooks/useDelayUnmount";
import classes from "./PromptModal.module.css";

const PromptModal = ({ confirmHandler, isMounted, setIsMounted, forceLtr, customMessage }) => {
  const showDiv = useDelayUnmount(isMounted, 550);

  const defaultMessage = forceLtr
    ? "Are You Sure Of Your Decision ?"
    : "آیا از حذف اطلاعات مطمئن هستید؟";

  return (
    <>
      {showDiv && (
        <div
          className={[classes.backdrop, isMounted ? classes.bdropMounted : classes.bdropUnmounted].join(
            " "
          )}
          onClick={() => setIsMounted((ps) => !ps)}
        />
      )}
      {showDiv && (
        <div
          className={[
            classes.confirmContainer,
            isMounted ? classes.modalMounted : classes.modalUnmounted,
          ].join(" ")}
        >
          <h3>{customMessage || defaultMessage}</h3>
          <div className={classes.bodyContainer}>
            <button className={classes.confirmBtn} onClick={confirmHandler}>
              {forceLtr ? "Confirm" : "بله"}
            </button>
            <button className={classes.cancelBtn} onClick={() => setIsMounted((ps) => !ps)}>
              {forceLtr ? "Cancel" : "خیر"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PromptModal;
